"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CredentialVariables;
(function(CredentialVariables) {
  CredentialVariables["region"] = "region";
  CredentialVariables["credentials"] = "credentials";
  CredentialVariables["credentials_azure"] = "credentials_azure";
  CredentialVariables["credentials_vmware"] = "credentials_vmware";
  CredentialVariables["credentials_k8"] = "credentials_k8";
  CredentialVariables["credentials_tfc"] = "credentials_tfc";
  /**
   * Credentials for Google Cloud Platform
   */
  CredentialVariables["credentials_gcp"] = "credentials_gcp";
  /**
   * Project name for which GCP credentials belong
   */
  CredentialVariables["project"] = "project";
  CredentialVariables["resourceGroup"] = "resourceGroup";
})(
  (CredentialVariables =
    exports.CredentialVariables || (exports.CredentialVariables = {}))
);
//# sourceMappingURL=variables.js.map
